import { forwardRef, useState } from 'react';
import styles from './addTimeSlots.module.css';
import TimePicker from '../../../reusable-ui-components/TimePicker';
import useSectionHighlightRef from '../../../../hooks/useSectionHighlightRef';
import DropdownReg from '../../../dropdownReg/DropdownReg';

const convertToMinutes = (time) => {
    if (!time) return null;
    console.log(time, 'initial Time');
    const [timeParts, period] = time.split(' ');
    let [hours, minuts] = timeParts.split(':').map(Number);

    if (period === 'PM' && hours !== 12) {
        hours += 12;
    }
    if (period === 'AM' && hours === 12) {
        hours = 0;
    }
    return hours * 60 + minuts;
};

const AddTimeSlots = forwardRef(({ data, setData, title, slotLabel }, ref) => {
    const [error, setError] = useState('');
    const datesType = ['everyday', 'fixed'];
    const { sectionRef, highlightField } = useSectionHighlightRef(ref);
    const addTimeSlots = () => {
        setData((prev) => ({
            ...prev,
            timeSlots: [
                ...prev.timeSlots,
                {
                    startTime: '',
                    endTime: '',
                    totalSlots: 1
                }
            ]
        }));
    };

    const deleteTimeSlots = () => {
        setData((prev) => ({
            ...prev,
            timeSlots: prev.timeSlots.slice(0, prev.timeSlots.length - 1)
        }));
    };

    const handleTimeChange = (index, field, value) => {
        setData((prev) => {
            const updated = [...prev.timeSlots];

            const currentSlot = {
                ...updated[index],
                [field]: value
            };

            updated[index] = currentSlot;

            const prevSlot = updated[index - 1];
            const nextSlot = updated[index + 1];

            // ✅ Validate start < end
            if (
                currentSlot.startTime &&
                currentSlot.endTime &&
                convertToMinutes(currentSlot.endTime) <= convertToMinutes(currentSlot.startTime)
            ) {
                setError('End time must be greater than start time');
                return prev;
            }

            // ✅ Validate with previous slot
            if (
                prevSlot?.endTime &&
                currentSlot.startTime &&
                convertToMinutes(currentSlot.startTime) <= convertToMinutes(prevSlot.endTime)
            ) {
                setError('Start time must be greater than previous slot end time');
                return prev;
            }

            // ✅ Validate with next slot
            if (
                nextSlot?.startTime &&
                currentSlot.endTime &&
                convertToMinutes(currentSlot.endTime) >= convertToMinutes(nextSlot.startTime)
            ) {
                setError('End time must be smaller than next slot start time');
                return prev;
            }

            // ✅ Duplicate check (optional but safe)
            const seen = new Set();
            for (let slot of updated) {
                if (slot.startTime && slot.endTime) {
                    const key = `${slot.startTime}-${slot.endTime}`;
                    if (seen.has(key)) {
                        setError('Duplicate time slot not allowed');
                        return prev;
                    }
                    seen.add(key);
                }
            }

            setError('');
            return { ...prev, timeSlots: updated };
        });
    };
    console.log(data);
    return (
        <div ref={sectionRef}>
            <h2 className={styles.orgPackUpH2}>{title}</h2>
            <div className='orgPackUpSecDiv'>
                {data?.timeSlots?.map((slot, index) => {
                    return (
                        <div key={index}>
                            <DropdownReg
                                label='DatesType'
                                name={'datesType'}
                                options={datesType}
                                value={data.datesType}
                                req={true}
                                setFormData={setData}
                                error={highlightField === 'datesType'}
                            />
                            {/* Start Time */}
                            <div className={`${styles.timeSlotsInDiv} ${error ? 'error-highlight' : ''}`}>
                                <label className='itineraryLabel'>Start Time</label>
                                <div className={styles.timeSlotsInputDiv}>
                                    <TimePicker
                                        value={slot.startTime}
                                        onChange={(val) => handleTimeChange(index, 'startTime', val)}
                                        error={highlightField === 'timeSlots'}
                                    />
                                </div>
                            </div>

                            {/* End Time */}
                            <div className={`${styles.timeSlotsInDiv} ${error ? 'error-highlight' : ''}`}>
                                <label className='itineraryLabel'>End Time</label>
                                <div className={styles.timeSlotsInputDiv}>
                                    <TimePicker
                                        value={slot.endTime}
                                        onChange={(val) => handleTimeChange(index, 'endTime', val)}
                                        error={highlightField === 'timeSlots'}
                                    />
                                </div>
                            </div>

                            {/* Total Slots */}
                            <div className={`${styles.timeSlotsInDiv} ${error ? 'error-highlight' : ''}`}>
                                <label className='itineraryLabel'>Total Slots</label>
                                <div className={styles.timeSlotsInputDiv}>
                                    <input
                                        type='number'
                                        min={1}
                                        value={slot.totalSlots}
                                        className='directInInput'
                                        style={{ width: '225px' }}
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            handleTimeChange(index, 'totalSlots', value === '' ? '' : Number(value));
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
                {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
                <div className={`alignButtons ${styles.timeSlotsBtn}`}>
                    <button type='button' onClick={() => addTimeSlots()} className={styles.timeSlotsAddBtn}>
                        Add Time Slot
                    </button>
                    <button
                        type='button'
                        onClick={() => deleteTimeSlots()}
                        className={styles.timeSlotsDelBtn}
                        disabled={data?.timeSlots?.length === 1}
                    >
                        Delete Time Slot
                    </button>
                </div>
            </div>
        </div>
    );
});

export default AddTimeSlots;
